export const PAGINATION_FIELDS = `
  total
  totalPages
  pageSize
  currentPage
`;

export const ID_NAME_FIELDS = `
  id
  name
`;

export const BROKER_ID_NAME_FIELDS = `
  id
  name
  company {
    ${ID_NAME_FIELDS}
  }
`;

export const COUNTRY_FIELDS = `
  id
  name
  code
  flagURL
  distanceMeasurement
  areaMeasurement
  currencyCode
`;

export const USER_BASIC_FIELDS = `
  id
  firstName
  lastName
  email
`;

export const ID_NAME_WEBSITE_LOGO_FIELDS = `
  id
  name
  website
  logoUrl
`;

export const PROPERTY_MAIN_FIELDS = `
  id
  name
  country
  state
  city
  primaryAddress
  secondaryAddress
  tertiaryAddress
  quaternaryAddress
  numberOfAlternativeAddresses
  displayAddress
  postalCode
  measurementSystem
  currencyCode
  buildingSize
  buildingSizeMt
  floorPlateSize
  floorPlateSizeMt
  latitude
  longitude
  latitudeDisplay
  longitudeDisplay
  coverMediaUrl
  coverMediaType
  builtYear
  buildDate
  stories
  type
`;

export const LEASE_ANALYTICS_ITEM_FIELDS = `
  id
  value
  size
  sizeMt
  measurementSystem
  timeMeasurement
  date
  year
  quarter
  currencyCode
  rentType
  baseRent
  baseRentFullServiceEquivMonthly
  baseRentFullServiceEquivAnnual
  baseRentNNNEquivMonthly
  baseRentNNNEquivAnnual
  baseRentFullServiceEquiv
  baseRentNNNEquiv
    tenantCompany {
    ${ID_NAME_FIELDS}
  }
`;

export const HISTORICAL_AVERAGE_LEASES_FIELDS = `
  id
  date
  rent
  size
  sizeMt
  currencyCode
  measurementSystem
`;

export const HISTORICAL_AVERAGE_AVERAGES_FIELDS = `
  date
  value
  valueMonthly
  NNNEquivValue
  NNNEquivValueMontly
  propertyValue
  totalSizeSF
  totalSizeSquareMeters
  leasesCount
  measurementSystem
  currencyCode
  topItems
`;

export const SALES_PRICING_ROOT_FIELDS = `
  minSalesPricing
  minCapRate
  maxSalesPricing
  maxCapRate
`;

export const SALES_PRICING_ITEMS_FIELDS = `
  year
  quarter
  avgCapRate
  avgSalesPricing
  topItems
`;

export const PROPERTY_CAROUSEL_FIELDS = `
  id
  name
  primaryAddress
  displayAddress
  coverMediaUrl
  coverMediaType
  `;
